<template>
  <div class="client-multi-check">
    <kt-autoselect
      :label="props.label"
      :options="clientOptions"
      display-by="Company"
      value-by="CustomerNumber"
      :multiple="true"
      v-model="model"
      search-placeholder="Search clients..."
      :on-refresh="handleRefresh"
      @change="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import KtAutoselect from '@/components/UI/KtAutoselect.vue';
import { useClientStore } from '@/stores/ClientStore';
import type { ClientModel } from '@/models/ClientModel';

const props = defineProps({
  label: { 
    type: String, 
    default: 'Select Clients' 
  }
});

const emit = defineEmits<{
  change: [value: number[]];
}>();

const model = defineModel<number[]>({
  default: () => []
});

const clientStore = useClientStore();
const clientOptions = ref<ClientModel[]>([]);

// Load clients on mount
onMounted(async () => {
  // The store auto-initializes, just wait for it
  await new Promise(resolve => setTimeout(resolve, 100));
  clientOptions.value = clientStore.list || [];
});

const handleChange = (value: number[]) => {
  emit('change', value);
};

const handleRefresh = async () => {
  await clientStore.refresh();
  clientOptions.value = clientStore.list || [];
};
</script>
